import { PART_BOT_RESULT_GROUPS } from '@frontend/api';

export const NAMESPACE = 'OnSelectLifeCycle' as const;

export const ANNOTATION_SELECTION_TYPES = {
  SELECTED: 'selected',
  DESELECTED: 'deselected',
} as const;

export const SUGGESTION_ANNOTATION_TYPES = {
  FIELD_SUGGESTION: 'FIELD_SUGGESTION',
  FOUND_IN_FILES: 'FOUND_IN_FILES',
  EXTRACTED_TABLE: 'EXTRACTED_TABLE',
  ACTION_EXTRACTION_TEXT: 'ACTION_EXTRACTION_TEXT',
} as const;

/** Serializable selectors for which viewer annotations a command applies to. */
export const SUGGESTION_ANNOTATION_PREDICATE_TYPES = {
  /** Annotations whose id is not in `nextStateAnnotationIds`. */
  NOT_IN_NEXT_STATE: 'NOT_IN_NEXT_STATE',
  /** Annotations that are currently focused in the viewer. */
  CURRENTLY_FOCUSED: 'CURRENTLY_FOCUSED',
} as const;

export const SUGGESTION_ANNOTATION_COMMAND_TYPES = {
  // loading - does not actually change any state - just hydrates into the state system
  //  and lets other commands dictate display behavior
  LOAD: 'LOAD',
  // standard commands
  SHOW: 'SHOW',
  HIDE: 'HIDE',
  FOCUS: 'FOCUS',
  UNFOCUS: 'UNFOCUS',
  DIM: 'DIM',
  UNDIM: 'UNDIM',
  WHITEOUT: 'WHITEOUT',
  UNWHITEOUT: 'UNWHITEOUT',
  // general purpose state merge
  MERGE_STATE_MULTIPLE: 'MERGE_STATE_MULTIPLE',
  // table extraction
  REFRESH_EXTRACTED_TABLES: 'REFRESH_EXTRACTED_TABLES',
  // Reqs Review
  PROCESS_ACTIONS: 'PROCESS_ACTIONS',
  RECEIVE_TEXT_EXTRACTIONS: 'RECEIVE_TEXT_EXTRACTIONS',
  // Focus management
  RELEASE_DOCUMENT_FOCUS: 'RELEASE_DOCUMENT_FOCUS',
  // Outbound commands consumed outside the viewer
  CREATE_PRINT_EXTRACTION: 'CREATE_PRINT_EXTRACTION',
  DELETE_PRINT_EXTRACTION: 'DELETE_PRINT_EXTRACTION',
  OPEN_RULE_CREATION: 'OPEN_RULE_CREATION',
} as const;

export const SUGGESTION_ANNOTATION_COMMAND_ORIGINS = {
  VIEWER: 'VIEWER',
  REQS_REVIEW: 'REQS_REVIEW',
  PART_FIELDS: 'PART_SETUP_TOOL',
  FOUND_IN_FILES: 'FOUND_IN_FILES',
} as const;

export const SUGGESTION_ANNOTATION_CATEGORIES = {
  FIELD: 'FIELD',
} as const;

export const SUGGESTION_SUBJECT = 'Suggestion' as const;

export const ANNOTATION_COLOR_CODES = {
  DEFAULT: '#8C41ED',
  [PART_BOT_RESULT_GROUPS.QUOTE_SETUP]: '#8C41ED',
  [PART_BOT_RESULT_GROUPS.FEATURES]: '#F59300',
  [PART_BOT_RESULT_GROUPS.DIMENSIONS]: '#33D1DE',
  [PART_BOT_RESULT_GROUPS.REQUIREMENTS]: '#1DC504',
  [SUGGESTION_ANNOTATION_CATEGORIES.FIELD]: '#8C41ED',
  REQS_REVIEW: '#315CEA',
  BLEEDING_ORANGE: '#FF771A',
  BLEEDING_ORANGE_LIGHT: '#FF8C3A',
} as const;

export const ANNOTATION_OPACITY = {
  DEFAULT_FILL: 0.15,
  DEFAULT_OUTLINE: 1.0,
  WHITEOUT: 0.95,
  FOCUS: 0.3,
  DEPRIORITIZED: 0.1,
  REGION_PATTERN_FOCUS: 0.25,
  REGION_PATTERN_DEFAULT: 0.15,
  REGION_WHITEOUT: 0.9,
  REGION_OUTLINE_DEFAULT: 0.6,
};

export const ANNOTATION_BORDER_WIDTH = {
  DEFAULT: 1.5,
  FOCUS: 3,
  HOVER: 2,
  BLEEDING_ORANGE: 4,
  DIMMED: 0,
  REGION_OUTLINE_FOCUS: 1,
  REGION_OUTLINE_DEFAULT: 0.5,
};
